import { generateBaseQueryKeysList } from '@/queries/utils';

export const NOTIFICATIONS_KEYS = {
  main: 'notifications',
};

export const notificationsQueryKeys = generateBaseQueryKeysList(NOTIFICATIONS_KEYS.main);
